var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFamilyHistory = function SvgIconFamilyHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 2,
    transform: "translate(1 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 5 11-5 11 5"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M9 18.836c0-.604-.265-1.179-.738-1.554C7.539 16.708 6.285 16 4.5 16s-3.039.708-3.762 1.282c-.473.375-.738.95-.738 1.554V20h9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 10.5,
    r: 2.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M22 18.836c0-.604-.265-1.179-.738-1.554C20.539 16.708 19.285 16 17.5 16s-3.039.708-3.762 1.282c-.473.375-.738.95-.738 1.554V20h9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 10.5,
    r: 2.5,
    strokeLinecap: "square"
  })))));
};
export { SvgIconFamilyHistory as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMS41KSIgc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjIiPgogICAgICAgICAgICA8cGF0aCBkPSJtMCA1IDExLTUgMTEgNSIvPgogICAgICAgICAgICA8cGF0aCBkPSJNOSAxOC44MzZjMC0uNjA0LS4yNjUtMS4xNzktLjczOC0xLjU1NEM3LjUzOSAxNi43MDggNi4yODUgMTYgNC41IDE2cy0zLjAzOS43MDgtMy43NjIgMS4yODJjLS40NzMuMzc1LS43MzguOTUtLjczOCAxLjU1NFYyMGg5di0xLjE2NHoiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KICAgICAgICAgICAgPGNpcmNsZSBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiBjeD0iNC41IiBjeT0iMTAuNSIgcj0iMi41Ii8+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0yMiAxOC44MzZjMC0uNjA0LS4yNjUtMS4xNzktLjczOC0xLjU1NEMyMC41MzkgMTYuNzA4IDE5LjI4NSAxNiAxNy41IDE2cy0zLjAzOS43MDgtMy43NjIgMS4yODJjLS40NzMuMzc1LS43MzguOTUtLjczOCAxLjU1NFYyMGg5di0xLjE2NHoiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KICAgICAgICAgICAgPGNpcmNsZSBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiBjeD0iMTcuNSIgY3k9IjEwLjUiIHI9IjIuNSIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";